/* eslint-disable angular/controller-as */
angular.module('maps')
  .controller('standAloneMapCtrl', function ( $scope, socketService, installationId,mapId,symbolId) {
    $scope.installationId = installationId;
    $scope.mapId = mapId;
    $scope.symbolId=symbolId;
  });
